import { useEffect, useMemo, useState } from "react";

export function useBonusCountdown(collectedAt?: string, bonusHours?: number) {
  const initial = useMemo(() => {
    if (!collectedAt || bonusHours == null) return 24 * 3600;

    // if (!collectedAt || bonusHours == null) return 0;
    const collected = Math.round(Date.parse(collectedAt) / 1000);
    const now = Math.round(Date.now() / 1000);
    return Math.max(0, collected + bonusHours * 3600 - now);
  }, [collectedAt, bonusHours]);

  const [remaining, setRemaining] = useState(initial);

  useEffect(() => {
    setRemaining(initial);
  }, [initial]);

  useEffect(() => {
    setRemaining(initial);
    if (initial <= 0) return;
    const id = setInterval(() => {
      setRemaining((s) => (s > 0 ? s - 1 : 0));
    }, 1000);
    return () => clearInterval(id);
  }, [initial]);

  const timeText = useMemo(() => {
    const s = remaining | 0;
    const h = String(Math.floor(s / 3600)).padStart(2, "0");
    const m = String(Math.floor((s % 3600) / 60)).padStart(2, "0");
    const sec = String(s % 60).padStart(2, "0");
    return `${h}:${m}:${sec}`;
  }, [remaining]);

  return { remainingSeconds: remaining, timeText, ready: remaining <= 0 };
}
